import { render, staticRenderFns } from "./AccountSidebarTab.vue?vue&type=template&id=dc2729a0&scoped=true&"
import script from "./AccountSidebarTab.vue?vue&type=script&lang=ts&"
export * from "./AccountSidebarTab.vue?vue&type=script&lang=ts&"
import style0 from "./AccountSidebarTab.vue?vue&type=style&index=0&id=dc2729a0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dc2729a0",
  null
  
)

export default component.exports